import "../style/azmoon-list/EnterExam.css";
import { useSelector } from "react-redux";
import { useState } from "react";

import img0 from "../../assets/azmoon-list/test.png";
import icon1 from "../../assets/azmoon-list/stickynote.png";
import icon2 from "../../assets/azmoon-list/teacher.png";
import icon3 from "../../assets/azmoon-list/clock.png";
import icon4 from "../../assets/azmoon-list/message-minus.png";
import icon5 from "../../assets/azmoon-list/Group 893.png";
import icon6 from "../../assets/azmoon-list/people.png";
import icon7 from "../../assets/azmoon-list/profile-2user.png";
import icon8 from "../../assets/azmoon-list/message-text-2.png";
// import avatar from "../../assets/azmoon-list/tushar-khandagale-dvtAuBHBAVQ-unsplash.jpg";
// import img1 from '../../assets/store/amazing-suggest/ella-olsson-KPDbRyFOTnE-unsplash.jpg';
// import img2 from '../../assets/store/amazing-suggest/antoine-dautry-_zsL306fDck-unsplash.jpg';
// import img3 from '../../assets/store/amazing-suggest/ahmed-almakhzanji-kshkB1i5_5o-unsplash.jpg';

import { Link } from "react-router-dom";
import moment from "jalali-moment";
import { useEffect } from "react";

// let common_data = [
//   {
//     id:1,
//     img:img1,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"450.200",
//     discounted_price:"405.000",
//     discount:"10%",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "discounted",
//     exam_filter:"none",
//     user_num:100,
//     max_user:130,
//     time:"9:30",
//     negetive_point:"دارد",
//     question_type:"تشریحی و تستی",
//     guide_file:"دارد",
//     guide_file_link:"#",
//     creator:{
//       avatar:avatar,
//       name:"موسسه فرهنگی مصباح نور"
//     },
//   },
//   {
//     id:2,
//     img:img3,
//     title:"آزمون زیست شناسی دهم",
//     // price:458.200,
//     price:"350.000",
//     discounted_price:"305.000",
//     discount:"10%",
//     date:"28 آبان 1400",
//     level:"کارشناسی",
//     type:"گروهی",
//     filter: "discounted",
//     exam_filter:"live",
//     user_num:100,
//     max_user:130,
//     time:"12:30",
//     negetive_point:"دارد",
//     question_type:"تشریحی و تستی",
//     guide_file:"دارد",
//     guide_file_link:"#",
//     creator:{
//       avatar:avatar,
//       name:"موسسه فرهنگی مصباح نور"
//     },
//   },
//   {
//     id:3,
//     img:img1,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"350.200",
//     discounted_price:"305.000",
//     discount:"10%",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "discounted",
//     exam_filter:"none",
//     user_num:100,
//     max_user:130,
//     time:"12:30",
//     negetive_point:"دارد",
//     question_type:"تشریحی و تستی",
//     guide_file:"دارد",
//     guide_file_link:"#",
//     creator:{
//       avatar:avatar,
//       name:"موسسه فرهنگی مصباح نور"
//     },
//   },
//   {
//     id:4,
//     img:img3,
//     title:"آزمون روان درمانی اگزیستانسیال",
//     // price:458.200,
//     price:"458.200",
//     discounted_price:"",
//     discount:"",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "none",
//     exam_filter:"collegiate",
//     user_num:100,
//     max_user:130,
//     time:"10:30",
//     negetive_point:"دارد",
//     question_type:"تشریحی و تستی",
//     guide_file:"دارد",
//     guide_file_link:"#",
//     creator:{
//       avatar:avatar,
//       name:"موسسه فرهنگی مصباح نور"
//     },
//   },
//   {
//     id:5,
//     img:img2,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"458.200",
//     discounted_price:"",
//     discount:"",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "none",
//     exam_filter:"collegiate",
//     user_num:90,
//     max_user:100,
//     time:"11:30",
//     negetive_point:"دارد",
//     question_type:"تشریحی و تستی",
//     guide_file:"دارد",
//     guide_file_link:"#",
//     creator:{
//       avatar:avatar,
//       name:"موسسه فرهنگی مصباح نور"
//     },
//   },
//   {
//     id:6,
//     img:img1,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"458.200",
//     discounted_price:"",
//     discount:"",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "none",
//     exam_filter:"none",
//     user_num:100,
//     max_user:120,
//     time:"12:30",
//     negetive_point:"دارد",
//     question_type:"تشریحی و تستی",
//     guide_file:"دارد",
//     guide_file_link:"#",
//     creator:{
//       avatar:avatar,
//       name:"موسسه فرهنگی مصباح نور"
//     },
//   },
//   {
//     id:7,
//     img:img1,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"350.000",
//     discounted_price:"",
//     discount:"",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "none",
//     exam_filter:"collegiate",
//     user_num:100,
//     max_user:130,
//     time:"12:30",
//     negetive_point:"دارد",
//     question_type:"تشریحی و تستی",
//     guide_file:"دارد",
//     guide_file_link:"#",
//     creator:{
//       avatar:avatar,
//       name:"موسسه فرهنگی مصباح نور"
//     },
//   },
//   {
//     id:8,
//     img:img2,
//     title:"آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price:"458.200",
//     discounted_price:"رایگان",
//     discount:"100%",
//     date:"28 آبان 1400",
//     level:"پایه 1 الی 12",
//     type:"گروهی",
//     filter: "free",
//     exam_filter:"none",
//     user_num:100,
//     max_user:130,
//     time:"12:30",
//     negetive_point:"دارد",
//     question_type:"تشریحی و تستی",
//     guide_file:"دارد",
//     guide_file_link:"#",
//     creator:{
//       avatar:avatar,
//       name:"موسسه فرهنگی مصباح نور"
//     },
//   }
// ]

const EnterExam = ({ ID }) => {
  const state = useSelector((state) => state.default);
  const [common_data] = useState(state.ExamData);
  console.log(common_data);
  let data;
  for (let i = 0; i < common_data.length; i++) {
    if (common_data[i].id === Number(ID)) {
      data = common_data[i];
    }
  }
  console.log("cc:"+data);
  //--today date--and timer setting-----------------------------
  let today = new Date();
  let examDate = new Date(data.date)
  console.log(today);
  console.log(examDate);
  let diff = (examDate-today)/1000;
  let d = Math.floor(diff/86400);
  console.log(d);
  let h = Math.floor((diff-(86400*d))/3600);
  console.log(h);
  let m = Math.floor((diff-(86400*d)-(h*3600))/60);
  console.log(m);
  let s = Math.floor(diff-(86400*d)-(h*3600)-(m*60));
  console.log(s);
  const [timer,setTimer]=useState({
    d,h,m,s
  })

  useEffect(() => {
    // console.log(sec);
    if (timer.s >= 0 && diff > 0) {
      setTimeout(() => {
        // console.log("okdkdokodkd");
        setTimer({
          d,
          h,
          m,
          s:s-1
        });
        if (timer.s === 0) {
          setTimer({
            d,
            h,
            m:m-1,
            s:59
          });
        }
        if (timer.m === 0) {
          setTimer({
            d,
            h:h-1,
            m:59,
            s:59
          });
        }
        if (timer.h === 0) {
          setTimer({
            d:d-1,
            h:23,
            m:59,
            s:59
          });
        }
      }, 1000);
    }
  });
  //-------------------------------------------
  moment.locale("en");
  return (
    <div className="enter-exam">
      <div className="enter-exam-box">
        <div className="eeb-title-box">
          <img className="eeb-title-box-img" src={img0} alt="title-box-img" />
          <div className="eeb-title-box-title">به {data?.name}</div>
          <div className="eeb-title-box-subtitle">خوش آمدید</div>
        </div>
        <div className="eeb-name-box">
          <img className="eeb-name-box-icon" src={icon1} alt="name-icon" />
          <div className="eeb-name-box-label">نام آزمون:</div>
          <div className="eeb-name-box-name">{data?.name.substr(6)}</div>
        </div>
        <div className="eeb-level-box">
          <img className="eeb-level-box-icon" src={icon2} alt="name-icon" />
          <div className="eeb-level-box-label">پایه تحصیلی:</div>
          <div className="eeb-level-box-level">{data?.level}</div>
        </div>
        <div className="eeb-date-box">
          <img className="eeb-date-box-icon" src={icon3} alt="name-icon" />
          <div className="eeb-date-box-label">زمان آزمون:</div>
          <div className="eeb-date-box-date">
            {moment(data?.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
          </div>
          <div className="eeb-date-box-time">ساعت 
            {examDate.getHours()}:{examDate.getMinutes()}
            
          </div>
        </div>
        <div className="eeb-negetive-point-and-question-type-box">
          <div className="eeb-np-box">
            <img className="eeb-np-box-icon" src={icon4} alt="name-icon" />
            <div className="eeb-np-box-label">نمره منفی:</div>
            <div className="eeb-np-box-have">
              {data?.negattiveMode && "دارد"}
              {!data?.negattiveMode && "ندارد"}
            </div>
          </div>
          <div className="eeb-qt-box">
            <img className="eeb-qt-box-icon" src={icon5} alt="name-icon" />
            <div className="eeb-qt-box-label">نوع سوالات:</div>
            <div className="eeb-qt-box-type">{data?.types}</div>
          </div>
        </div>
        <div className="eeb-max-user-and-exam-type-box">
          <div className="eeb-mu-box">
            <img className="eeb-mu-box-icon" src={icon6} alt="name-icon" />
            <div className="eeb-mu-box-label">حدنصاب شرکت کنندگان: </div>
            <div className="eeb-mu-box-number">{data?.capacity} نفر</div>
          </div>
          <div className="eeb-et-box">
            <img className="eeb-et-box-icon" src={icon7} alt="name-icon" />
            <div className="eeb-et-box-label">نوع شرکت در آزمون:</div>
            <div className="eeb-et-box-type">
              {data?.type===1 && "انفرادی"}
              {data?.type===2 && "گروهی"}
            </div>
          </div>
        </div>
        <div className="eeb-guide-box">
          <img className="eeb-guide-box-icon" src={icon8} alt="name-icon" />
          <div className="eeb-guide-box-label">فایل راهنما:</div>
          <div className="eeb-guide-box-have">
            {data?.guideFileId && "دارد"}
            {!data?.guideFileId && "ندارد"} -</div>
          <Link
            to={data?.guideFileId || "#"}
            className="eeb-guide-box-link"
          >
            دریافت فایل
          </Link>
        </div>
        <div className="eeb-created-box">
          <div className="eeb-created-box-img-container">
            <img
              className="eeb-created-box-icon"
              src={data?.creator.avatar}
              alt="name-icon"
            />
          </div>
          <div className="eeb-created-box-label">ایجاد شده توسط</div>
          <div className="eeb-created-box-file">{data?.creator.name}</div>
        </div>
        {(new Date(data.date)<today) &&<Link
          to={`/dashboard/azmoon_list/exam/${data?.id}`}
          className="eeb-btn"
        >
          شروع آزمون
        </Link>}
        {(new Date(data.date)>today) && 
          <div className="eeb-timer">
            <div>{timer.d} روز و </div>
            <div>{timer.h} ساعت و </div>
            <div>{timer.m} دقیقه و </div> 
            <div>{timer.s} ثانیه </div>
            <div>تا شروع آزمون</div>
          </div>
        }
      </div>
    </div>
  );
};

export default EnterExam;
